import React, { useState, useRef } from 'react';
import MenuBar from './common/MenuBar';
import { ChevronLeft } from 'lucide-react';
import toast ,{ Toaster } from 'react-hot-toast'; 
import { LoadSearchMember, GetPathForMember, LoadEmpContracts, SaveDocument, SavePrescriptionDocument, CreateAuth, CreateTask, SaveUploadedDocForAuth, uploadDocumentMainPathCreator } from '../Services/loadOrder';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import { useNavigate } from 'react-router-dom';
import { pageCount } from 'tiff';
import UploadSuccessModal from './common/UploadSuccessModal';

const UploadDocuments = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilescount, setSelectedFilesCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [empContractsValidator, setEmpContractsValidator] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  // const [successCount, setSuccessCount] = useState(0);
  // const [selectedFilescount, setSelectedFilesCount] = useState(0);
  const user = JSON.parse(localStorage.getItem('user'));
  const pharmacyID = user?.pharmacyId;
  const userID = user?.userId;
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  function escapeXml(unsafe) {
  return unsafe.replace(/[<>&'"]/g, function (c) {
    switch (c) {
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '&': return '&amp;';
      case '\'': return '&apos;';
      case '"': return '&quot;';
    }
  });
}

  const getPdfPageCount = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    return pdf.numPages;
  };

  const getTiffPageCount = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    return pageCount(arrayBuffer); // Returns the number of pages
  };

  const handleSearch = async () => {
    setSelectedMember(null);
    setSelectedFiles([]);
    if (!firstName || !lastName || !dob) {
    if (!firstName ) {
      toast.error('Please enter first name');
      return;
    } else if (!lastName ) {
      toast.error('Please enter last name');
    } else if (!dob ) {
      toast.error('Please enter date of birth');
    }
      return;
  }

  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  if (!dateRegex.test(dob)) {
    toast.error("Invalid date format. Please use MM/DD/YYYY.");
    return;
  }

    const result = await LoadSearchMember(firstName, lastName, dob);
    if (result?.TaskDetails?.length) {
      setSearchResults(result.TaskDetails);
      setShowResults(true);
    } else {
      setSearchResults([]);
      setShowResults(false);
      toast.error('There is no member present with the combination entered.');
    }
  };

  const handleRowClick = (row) => {
    setSelectedMember(row);
    setShowResults(false);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles((prev) => [...prev, ...files]);
  };

  // helper function to convert file to base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data URL prefix
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleSendToWin = async () => {
    if (!selectedMember || !selectedFiles.length) {
      toast.error('Please select a member and files.');
      return;
    }
    setLoading(true);

    const Memberid = selectedMember.PatientID;
    const userName = `${pharmacyID}-${userID}`; // same as Session["user"] in legacy
    let fileId = 1; // legacy always 1 for upload
    let displayContract = selectedMember.Contract; // full contract text for checks
    let pathContract = displayContract.includes('DTC') ? 'DTC' : displayContract; // used only for path rules

    // 1) Load employer contracts (same as GetEmployersContracts())
    let empContractsResp = [];
    if (displayContract !== 'Moelis-Cigna-Premier Rx'){
    empContractsResp = await LoadEmpContracts(displayContract);
  }
    const empContracts = empContractsResp?.Detail || [];
    let flagEmployer = false;
    const isEmployerContract = empContracts.some(e => {
      if (e.Contract === displayContract) {
        flagEmployer = true;
        return true;
    }
    return false;
});
console.log('flagEmployer', flagEmployer); 
let docTypeDescription = '';

  if (flagEmployer) {
      docTypeDescription = 'Prescription';
  } else { 
      docTypeDescription = 'Pharmacy Uploaded Document';
  }

    // constants to mirror legacy
    const DUMMY_PROVIDER_ID = '1234567891';
    const DUMMY_GROUP_ID = '526789412';
    const DUMMY_ADDRESS_ID = 814498;
    const DX = 'N97.9';
    const BENEFIT = 'Rx Only';

    let successCount = 0;

    for (const file of selectedFiles) {
      const fileName = file.name;
      const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();

      // legacy validations
      if (['.doc', '.docx'].includes(ext)) { toast.error(`${fileName}: Invalid file type.`); continue; }
      if (!['.pdf', '.tiff', '.tif', '.jpeg', '.jpg', '.bmp'].includes(ext)) { toast.error(`${fileName}: Invalid file type.`); continue; }
      if (file.size > 10485760) { toast.error(`${fileName}: File is too large (>10MB).`); continue; }

      try {
        // 2) Get member folder path (like CreateFolderStructure -> GetPathForMemberController)
        let pathResp = null;
        let basePath  = null;
        if (docTypeDescription !== '') {
        pathResp = await GetPathForMember(Memberid, displayContract,
           selectedMember.ContractCode, docTypeDescription);

           basePath = pathResp?.Path || '';
        }
      
        if (!basePath && Array.isArray(pathResp)) {
          for (const dr of pathResp) basePath = dr?.Path?.toString() || '';
        }
        if (!basePath) { toast.error(`${fileName}: Member path not found.`); continue; }

        // 3) Build a **versioned** file path (Prescription-Ver{n}{ext}) as in legacy
        const stamp = Date.now(); // deterministic, sortable
        const versionFile = `Prescription-Ver${stamp}${ext}`;
        const cleanedBasePath = basePath.replace(/\\+$/, ''); // remove trailing backslashes
        const versionPath = `${cleanedBasePath}\\${versionFile}`;

        // 4) Page count (mirror legacy)
        let numPages = 1;
        if (ext === '.pdf') {
          try { numPages = await getPdfPageCount(file); } catch { numPages = 1; }
        } else if (ext === '.tif' || ext === '.tiff') {
          try { numPages = await getTiffPageCount(file); } catch { numPages = 1; }
        } else {
          numPages = 1; // jpg/jpeg/bmp
        }

        // 5) Write the file to the filesystem path first (legacy physically moved file before saving doc row)
        const inputBytes = await fileToBase64(file);
        let documentItem = null;
        if (docTypeDescription !== '') {
         documentItem = {
          FileID: fileId,                           // always 1 in legacy
          FilePath: versionPath,
          FileName: versionFile,                  // **versioned name**
          NoOFPages: numPages,
          DocTypeDesc: docTypeDescription,
          inputBytes,
          fileSize: file.size,
          memberId: Memberid,
          contract: displayContract,              // full contract text
          contractCode: selectedMember.ContractCode,
          docTypeDescription: docTypeDescription
        };
        fileId += 1; // increment for next file (not used in legacy upload)
      }
       
        if (documentItem !== null) {
        await uploadDocumentMainPathCreator([documentItem]); // create the file at versionPath
        }
        // 6) Build documents XML EXACTLY like legacy (FileName must match versioned file)
        const documents =
  `<Documents><Item FileID="1" FilePath="${escapeXml(versionPath)}" FileName="${escapeXml(versionFile)}" NoOFPages="${numPages}" /></Documents>`;
        if (isEmployerContract) {
          // Employer flow (legacy SaveDocuments -> employer branch)

          // 6a) Save bytes / create doc row (Save_Bytes_forUoloadDocument equivalent)
          // legacy passes many params incl. "Infertility" specialty and doc type "Prescription"
          const faxResp = await SavePrescriptionDocument(
            displayContract,             // Contract (full)
            Memberid,                    // member id
            userName,                    // username
            documents, 
            docTypeDescription,                  // xml
            DUMMY_PROVIDER_ID,           // provider
            DUMMY_GROUP_ID,              // group
            /* optionally include: specialty 'Infertility', docType 'Prescription' if your API needs them */
          );
          const faxid = faxResp.FaxId || '';
          if (!faxid) { toast.error(`${fileName}: No FaxId returned.`); continue; }

          // 6b) Create Auth (CreateAuthForUploadDocument)
          const authResp = await CreateAuth(
            displayContract,
            Memberid,
            DUMMY_PROVIDER_ID,
            DUMMY_ADDRESS_ID,
            DUMMY_GROUP_ID,
            BENEFIT,                    // 'Rx Only'
            DX,                         // 'N97.9'
            userName
          );
          const authData = authResp;
          const authOut = authData.AuthNo_OutID;
          if (!authOut) { toast.error(`${fileName}: Auth not created.`); continue; }
          const authId = authOut.split(',')[0]; // AuthNo
          const formattedAuth = authData.FormattedAuthNo;

          // 6c) Create Task (CreateTask)
          // legacy: CreateTask(NewConnStr, contract, memberid, username, "Online Rx Request", "CSA-Online-Queue", AuthNumber, "Request for Rx Authorization... ")
          await CreateTask(
            displayContract,
            Memberid,
            userName,
            authId,
            "Online Rx Request",         // task name
            "CSA-Online-Queue",          // queue
            "Request for Rx Authorization. Pharmacy user uploaded the doc" // description
          );

          // 6d) Link uploaded doc to auth (SaveUploadedDocForAuth)
          // legacy signature: SaveUploadedDocForAuth(NewConnStr, FormattedAuthNumber, faxid + ",", memberid, contract)
          await SaveUploadedDocForAuth(
            `${faxid}`,
            Memberid,
            formattedAuth,
            displayContract
          );
        } else {
          // Non-employer flow (SaveDocumentsForMemberController equivalent)
          await SaveDocument(displayContract, Memberid, userName, documents);
        }

        successCount += 1;
        setSuccessCount(successCount);
        setSelectedFilesCount(selectedFiles.length);
      } catch (err) {
        console.error(err);
        toast.error(`Error uploading ${fileName}`);
        // continue with remaining files instead of navigating away
        continue;
      } 
    };
    
    setLoading(false);



    if (successCount > 0) {
      // toast.success(`Files sent to WIN! (${successCount}/${selectedFiles.length})`);
      setSelectedFiles([]);
      setShowSuccessModal(true); // Show confirmation modal
    } else {
      toast.error('No files were uploaded.');
    }
   
  

  };

  return (
    <div>
      <Toaster position='top-right'/>
      <MenuBar/>
      <div className='top-page-option'>
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
          <a 
            href="#/home" 
            style={{
              textDecoration: 'none',
              color: '#ec088c',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <ChevronLeft color='#ec088c' size={18} />
            <span style={{ marginLeft: '5px' }}>Back</span>
          </a>
        </div>

        <div className='top-page-option-name'>
          Upload Documents
        </div>
      </div>
      
            <h2 style={{ marginTop: '-30px', color: '#ec008c' }}>Attach Documents</h2>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '130px', marginBottom: '0px' }}>
                <span style={{ fontWeight: 'bold', color: 'black', fontSize: '14px', color: '#ec008c' }}>Search Member</span>
                <span style={{ color: 'red', fontSize: '12px', fontWeight: 500, marginTop: '5px' }}>
                    This member search tool will show you members that have WIN management for their Prescriptions.<br />
                    If the member is not found here and you are not getting a specific rejection saying you need Prior Auth from WIN, then we do not manage this member for the Prescription benefit and you should follow up with the health plan or PBM.
                </span>
            </div>
            <div style={{display: "flex",justifyContent: "center",
                alignItems: "center",margin: "20px auto",
                padding: "8px",maxWidth: "80%",
                border: "1px solid #ec008c",
                borderRadius: "8px",
                flexWrap: "wrap",
                gap: "60px",
                backgroundColor: "#fff"}}>
                <div style={{ marginLeft: "-18px" }}>
                    <label htmlFor="FirstName" >First Name: </label>
                    <input type="text" style={{ height: "20px", padding: '5px 5px', borderRadius: '4px', border: '1px solid #ccc' , outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ccc';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }} value={firstName} onChange={e => setFirstName(e.target.value)} />
                </div>
                <div style={{ marginLeft: "-50px" }}> 
                    <label htmlFor="LastName">Last Name: </label>
                    <input type="text" style={{ height: "20px", padding: '5px 5px', borderRadius: '4px', border: '1px solid #ccc' , outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ccc';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }} value={lastName} onChange={e => setLastName(e.target.value)} />
                </div>
                <div style={{ marginLeft: "-50px" }}>
                  <label htmlFor="DateofBirth">Date of Birth: </label>
                  <input
                    type="text"
                    min="1800-01-01"
                    max="2099-12-31"
                    placeholder="MM/DD/YYYY"
                    style={{ height: "20px", padding: '5px 5px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', transition: 'all 0.3s ease' }}
                    onFocus={e => {
                      e.target.style.border = '1px solid #ec008c';
                      e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
                    }}
                    onBlur={e => {
                      e.target.style.border = '1px solid #ccc';
                      e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                    }}
                    value={dob}
                    onChange={e => {
                      let value = e.target.value.replace(/[^\d]/g, ''); // Remove non-digits
                      if (value.length > 2) value = value.slice(0,2) + '/' + value.slice(2);
                      if (value.length > 5) value = value.slice(0,5) + '/' + value.slice(5,9);
                      setDob(value.slice(0, 10)); // Limit to MM/DD/YYYY
                    }}
                  />
                </div>
                <div style={{margin: "5px",marginLeft: "40px"}}>
                    <button type = "button" style={{
                        backgroundColor: "#ec008c",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer"
                    }} onClick={handleSearch}>Search</button>
                </div>
                <div style={{margin: "5px",marginLeft: "-60px"}}>
                    <button type = "button" style={{
                        backgroundColor: "#ec008c",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer"
                    }}onClick={() => window.location.reload()}>Clear</button>
                </div>

            </div>
            {showResults && (
                <div style={{ margin: '20px auto', maxWidth: '80%' }}>
                    <div style={{ color: '#ec008c', fontWeight: 'bold', marginBottom: '10px', fontSize: '16px' }}>
                        Choose a member from the below grid
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px',fontFamily: 'Segoe UI',background:'#fff' ,boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                        <thead>
                            <tr style={{ background: '#ec008c' }}>
                                <th style={{ border: '1px solid #e0e0e0', padding: '16px 4px',color:'#fff', fontWeight:400, textAlign:'left' }}>Patient ID</th>
                                <th style={{ border: '1px solid #e0e0e0', padding: '16px 4px',color:'#fff', fontWeight:400, textAlign:'left' }}>Last Name</th>
                                <th style={{ border: '1px solid #e0e0e0', padding: '16px 4px',color:'#fff', fontWeight:400 , textAlign:'left'}}>First Name</th>
                                <th style={{ border: '1px solid #e0e0e0', padding: '16px 4px',color:'#fff', fontWeight:400, textAlign:'left' }}>DOB</th>
                                <th style={{ border: '1px solid #e0e0e0', padding: '16px 4px',color:'#fff', fontWeight:400, textAlign:'left' }}>Address</th>
                                <th style={{ border: '1px solid #e0e0e0', padding: '16px 4px',color:'#fff', fontWeight:400, textAlign:'left' }}>E Mail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {searchResults.map((row, idx) => (
                                <tr key={idx}>
                                    <td style={{ border: '1px solid #e0e0e0', padding: '8px', cursor: 'pointer', color: 'black', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row.PatientID || ''}</td>
                                    <td style={{ border: '1px solid #e0e0e0', padding: '6px', cursor: 'pointer', color: 'black', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row.LastName || ''}</td>
                                    <td style={{ border: '1px solid #e0e0e0', padding: '6px', cursor: 'pointer', color: 'black', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row.FirstName || ''}</td>
                                    <td style={{ border: '1px solid #e0e0e0', padding: '6px', cursor: 'pointer', color: 'black', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row.DOB || ''}</td>
                                    <td style={{ border: '1px solid #e0e0e0', padding: '6px', cursor: 'pointer', color: 'black', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row.Address || ''}</td>
                                    <td style={{ border: '1px solid #e0e0e0', padding: '6px' }}>{row.Email || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {selectedMember && (
    <>
    <div style={{ margin: '20px auto', maxWidth: '80%', color: 'black', fontSize: '14px', background: 'none', border: 'none', padding: 0 }}>
        <b>Patient ID:</b> {selectedMember.PatientID || ''} &nbsp;  &nbsp; 
        <b>Patient First Name:</b> {selectedMember.FirstName || ''} &nbsp;  &nbsp; 
        <b>Patient Last Name:</b> {selectedMember.LastName || ''} &nbsp;  &nbsp; 
        <b>DOB:</b> {selectedMember.DOB || ''}
    </div>
    <div style={{ color: 'red', fontWeight: 500, fontSize: '13px', maxWidth: '80%', marginLeft: '100px', marginRight: 'auto', textAlign: 'center' }}>
        Only PDF, tiff, Jpeg, Bitmap files are allowed to upload
    </div>
    {/* Attachments UI */}
    <div style={{ display: 'flex', alignItems: 'center', margin: '30px 0 10px 10%', maxWidth: '80%' }}>
        <span style={{ fontWeight: 'bold', fontSize: '15px', marginRight: '16px' }}>Attachments :</span>
        <input
            type="file"
            multiple
            accept=".pdf,.tiff,.tif,.jpeg,.jpg,.bmp,.png"
            style={{ marginRight: '10px' }}
            onChange={handleFileChange}
            ref={fileInputRef}
        />
    </div>
    {/* Files sent to WIN table */}
     {/* Files sent to WIN table */}
          <div style={{ margin: '10px 0 0 10%', maxWidth: '80%', textAlign: 'left' }}>
            <span style={{ fontWeight: 'bold', fontSize: '15px' }}>Files sent to WIN:</span>
            <table className="uploaded-files-table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>View</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {selectedFiles.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.name}</td>
                    <td style={{ textAlign: 'center' }}>
                      <button
                        type="button"
                        className="file-action-btn view-btn"
                        title="View"
                        onClick={() => {
                          const fileURL = URL.createObjectURL(item);
                          window.open(fileURL, '_blank');
                        }}
                      >
                        {/* view and remove option */}
                        <span role="img" aria-label="view">🔍</span>
                      </button>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <button
                        type="button"
                        className="file-action-btn remove-btn"
                        title="Remove"
                        onClick={() => {
                          setSelectedFiles(prev => {
                            const updated = prev.filter((_, i) => i !== idx);
                            setSelectedFilesCount(updated.length);
                            // Reset file input if no files left
                            if (updated.length === 0 && fileInputRef.current) {
                              fileInputRef.current.value = '';
                            }
                            return updated;
                          });
                        }}
                      >
                        <span role="img" aria-label="remove">❌</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
         
           {/* Send to WIN button */}
          <div style={{ margin: '20px 0 0 10%' }}>
            <button type="button" style={{
                backgroundColor: "#ec008c",
                color: "white",
                padding: "10px 24px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: 600
            }} onClick={handleSendToWin}>Send prescription to WIN</button>
          </div>
          <div>
    {loading && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(255,255,255,0.7)',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          border: '6px solid #f3f3f3',
          borderTop: '6px solid #EC088C',
          borderRadius: '50%',
          width: 48,
          height: 48,
          animation: 'spin 1s linear infinite'
        }} />
        <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
      </div>
    )}
    {/* ...rest of your component... */}
  </div>
        </>
      )}
      <UploadSuccessModal
        open={showSuccessModal}
        onClose={() => {
          setShowSuccessModal(false);
          setFirstName(firstName);
          setLastName(lastName);
          setDob(dob);
          setSearchResults([]);
          setShowResults(false);
          setSelectedMember(null);
          setSelectedFiles([]);
          setEmpContractsValidator(false);
        }}
        successCount={successCount}
        selectedFilescount={selectedFilescount}
      />
    </div>
  );
};

export default UploadDocuments;